import Referral from './referral.web';

export default Referral;
